"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userCanViewStats;
// CHAR - chair also has access to calendar.
function userCanViewStats(user) {
  return user && (user.isAdmin || user.hasStatsAccess);
}